import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { getIntervalTimeOptions } from '../../../models/UiUtils';
import { IInterval } from '../../../viewmodels/AppViewModels';
import { DefaultSelectBox, ISelectBoxOption } from '../../../web/components/SelectBox';
import { baseStyleSheet } from '../../../web/styles/styles';
import { styleSheet } from './styles';

interface IProps {
	canRemove?: boolean;
	className?: string;
	disabled?: boolean;
	interval?: IInterval;
	isFriday?: boolean;
	onUpdateInterval?(interval: IInterval): void;
	styles?: StyleDeclarationValue[];
}

export const defaultInterval: IInterval = {
	endMinutes: 18 * 60,
	startMinutes: 8 * 60,
};

export class IntervalDropdowns extends React.Component<IProps> {
	private scheduleOptions: ISelectBoxOption<number>[];
	constructor(props: IProps) {
		super(props);
		this.scheduleOptions = getIntervalTimeOptions();
	}

	public render() {
		const { canRemove, className, disabled, interval, isFriday, styles } = this.props;

		if (!interval || (interval.startMinutes === 0 && interval.endMinutes === 0)) {
			return (
				<div className={css(styleSheet.container)}>
					<div className={css(styleSheet.promptText)}>
						{isFriday ? 'Same hours as Mon-Thur' : 'Outside business hours'}
					</div>
					<button className={css(baseStyleSheet.brandLink)} onClick={this.onAddHours}>
						{isFriday ? 'Change Hours' : 'Add Hours'}
					</button>
				</div>
			);
		}

		return (
			<div className={`${css(styleSheet.container, ...(styles || []))} interval-dropdowns ${className || ''}`}>
				<DefaultSelectBox
					className={css(styleSheet.dropDown)}
					disabled={disabled}
					menuStyles={[styleSheet.dropDownOption]}
					onSelectionChanged={this.updateStartMinutes}
					options={this.scheduleOptions}
					selectedOption={this.scheduleOptions.find(x => x.value === interval?.startMinutes)}
					triggerStyles={[styleSheet.dropDownOption]}
				/>
				<div className={css(styleSheet.toText)}>to</div>
				<DefaultSelectBox
					className={css(styleSheet.dropDown)}
					disabled={disabled}
					menuStyles={[styleSheet.dropDownOption]}
					onSelectionChanged={this.updateEndMinutes}
					options={this.scheduleOptions}
					selectedOption={this.scheduleOptions.find(x => x.value === interval?.endMinutes)}
					triggerStyles={[styleSheet.dropDownOption]}
				>
					{this.scheduleOptions?.map(x => (
						<option key={`end-${x.value}`} value={x.value}>
							{x.title as React.ReactNode}
						</option>
					))}
				</DefaultSelectBox>
				{!!canRemove && (
					<button className={css(baseStyleSheet.linkDestructive, styleSheet.removeButton)} onClick={this.onRemoveHours}>
						Remove
					</button>
				)}
			</div>
		);
	}

	private onAddHours = () => {
		const { onUpdateInterval } = this.props;

		onUpdateInterval(defaultInterval);
	};

	private onRemoveHours = () => {
		const { onUpdateInterval } = this.props;

		onUpdateInterval(undefined);
	};

	private updateStartMinutes = (selectedOption: ISelectBoxOption<number>) => {
		const { interval, onUpdateInterval } = this.props;

		onUpdateInterval({
			endMinutes: interval.endMinutes,
			startMinutes: selectedOption.value,
		});
	};

	private updateEndMinutes = (selectedOption: ISelectBoxOption<number>) => {
		const { interval, onUpdateInterval } = this.props;

		onUpdateInterval({
			endMinutes: selectedOption.value,

			startMinutes: interval.startMinutes,
		});
	};
}
